import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FileManagerService } from './file-manager.service';
import { SharedModule } from '../../../core/modules/shared.module';
import { FileManagerComponent } from './file-manager.component';
import { FileListComponent } from './file-list/file-list.component';
import { TicketsService } from '../tickets/tickets.service';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfModalModule } from '../../../core/pdf-modal/pdf-modal.module';
import { PdfModalService } from '../../../core/pdf-modal/pdf-modal.service';
import { NgxGalleryModule } from 'ngx-gallery';
import { ListaModalComponent } from '../../../core/components/lista-modal/lista-modal.component';
import { SelectorModule } from '../selector/selector.module';

const routes: Routes = [
    {
        path     : 'docs',
        component: FileManagerComponent
    },
    {
        path     : 'docs/:accion',
        component: FileManagerComponent
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes),
        NgxQRCodeModule,
        PdfViewerModule,
        PdfModalModule,
        NgxGalleryModule,
        SelectorModule
    ],
    declarations: [
        FileManagerComponent,
        FileListComponent
    ],
    providers   : [
        FileManagerService,
        TicketsService,
        PdfModalService
    ],
    entryComponents: [
        ListaModalComponent
    ]
})
export class FileManagerModule
{
}



// WEBPACK FOOTER //
// ./src/app/main/content/file-manager/file-manager.module.ts